import { render, staticRenderFns } from "./AboutCompanySubmenu.vue?vue&type=template&id=783ef3e0"
import script from "./AboutCompanySubmenu.vue?vue&type=script&lang=js"
export * from "./AboutCompanySubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports